<mat-progress-bar
    class="ds-loading-bar"
    [ngClass]="['ds-loading-bar--' + size, 'ds-loading-bar--' + theme]"
    [style.color]="color"
    [mode]="mode"
    [value]="value"
    [attr.aria-label]="ariaLabel"
></mat-progress-bar>
